/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

      {/* Company */}
      <SidebarMenuItem to='/companies' icon='briefcase' title='Company' fontIcon='bi-layers' />

      {/* Product Master */}
      <SidebarMenuItem to='/products' icon='star' title='Product Master' fontIcon='bi-layers' />

      {/* Accounts */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            Accounting Master
          </span>
        </div>
      </div>
      {/* <SidebarMenuItemWithSub
        to='/transactions'
        title='Accounting Master'
        fontIcon='bi-archive'
        icon='element-plus'
      > */}
      <SidebarMenuItem to='/transactions/enter' title='Enter Transactions' icon='row-horizontal' />

      <SidebarMenuItem to='/transactions/view' title='View Transactions' icon='eye' />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            Accounting Reports
          </span>
        </div>
      </div>

      <SidebarMenuItem
        to='/transactions/trial-balance'
        title='Trial Balance'
        icon='finance-calculator'
      />

      <SidebarMenuItem to='/transactions/aging-report' title='Aging Report' icon='chart-simple' />

      <SidebarMenuItem to='/profitandloss' title='P&L Report' icon='chart-pie-simple' />

      <SidebarMenuItem to='/balancesheet' title='Balance Sheet' icon='book' />

      <SidebarMenuItem to='/register' title='Register' icon='book-open' />

      {/* Inventory Management */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            Inventory Management
          </span>
        </div>
      </div>
      <SidebarMenuItem to='/warehouse-management' title='Warehouse Management' icon='bank' />
      <SidebarMenuItem to='/product-catalogue' title='Product Catalogue' icon='shop' />
      <SidebarMenuItem to='/stock/initial-assignment' title='Stock Management' icon='package' />
      <SidebarMenuItem to='/returns-management' title='Returns Management' icon='arrows-loop' />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            Inventory Reports
          </span>
        </div>
      </div>
      <SidebarMenuItem to='/stock-levels' title='Stock Levels' icon='graph-3' />
      <SidebarMenuItem to='/stock-valuation' title='Stock Valuation' icon='bill' />
      <SidebarMenuItem to='/inventory-ageing' title='Inventory Ageing' icon='chart-line-star' />
      <SidebarMenuItem to='/return-scrap' title='Return & Scrap' icon='trash' />
      <SidebarMenuItem to='/movement-report' title='Movement Report' icon='chart-line' />
      <SidebarMenuItem to='/profitability-report' title='Profitability' icon='percentage' />

      {/* Cost / Profit Center Management */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            Cost / Profit Center
          </span>
        </div>
      </div>
      <SidebarMenuItem
        to='/cost-center-management'
        title='Cost Center Management'
        icon='filter-search'
      />
      <SidebarMenuItem
        to='/profit-center-management'
        title='Profit Center Management'
        icon='graph-up'
      />
      <SidebarMenuItem to='/expense-management' title='Expense Management' icon='price-tag' />

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>General</span>
        </div>
      </div>

      <SidebarMenuItem to='/settings' icon='setting-2' title='Settings' fontIcon='bi-layers' />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Import Data</span>
        </div>
      </div>

      <SidebarMenuItem
        to='/uploadRecords'
        icon='add-files'
        title='Upload Records'
        fontIcon='bi-layers'
      /> */}
    </>
  )
}

export {SidebarMenuMain}
